// @ts-nocheck
/* eslint-disable react/jsx-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useRef, useEffect } from 'react';

import { Link } from 'react-router-dom';
import { useTable, Column, useBlockLayout } from 'react-table';

import Container, { RelativeContainer, CustomTableCellCN } from './styles';

import 'styled-components/macro';
import { Table, TableBody, TableHead, TableRow, TableCell } from '@material-ui/core';

import { theme } from 'styles';

interface Actions {
  [key: string]: (args: any) => void;
}

interface TableInterface<T extends object> {
  columns: Column<T>[];
  data: T[];
  actions?: Actions;
  redirectTo?: string;
  renderTableCell?: (cell: any) => React.ReactElement;
  selectedRow?: number;
  onCellClick?: () => void;
}

export function TableCN<T extends object>({
  columns,
  data,
  actions,
  redirectTo,
  renderTableCell,
  selectedRow,
}: TableInterface<T>) {
  const defaultColumn = { minWidth: 150 };
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable<T>(
    {
      columns,
      data,
      defaultColumn,
      ...actions,
    },
    useBlockLayout,
  );

  const [absoluteHeight, setAbsoluteHeight] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    setAbsoluteHeight(ref.current.clientHeight);
  }, []);

  return (
    <div style={{ width: '100%' }}>
      <RelativeContainer>
        <Container ref={ref} style={{ borderRadius: '1.5rem' }}>
          <Table aria-labelledby="tableTitle" size="small" aria-label="enhanced table" {...getTableProps()}>
            <TableHead style={{ background: theme.palette.background.default }}>
              <TableRow>
                {headerGroups.map(headerGroup =>
                  headerGroup.headers.map(column => (
                    <TableCell
                      key={column.id}
                      align="left"
                      {...column.getHeaderProps()}
                      width={column?.width || ''}
                      style={{
                        fontFamily: 'Proxima Nova',
                        color: theme.palette.inherit.dark,
                        fontWeight: 700,
                        textTransform: 'uppercase',
                      }}
                    >
                      {column.render('Header')}
                    </TableCell>
                  )),
                )}
              </TableRow>
            </TableHead>
            <TableBody {...getTableBodyProps()}>
              {rows.map((row, idx) => {
                prepareRow(row);
                return (
                  <TableRow className="table-header" hover tabIndex={-1} key={row?.id}>
                    {row.cells.map(cell => {
                      const { bold, a } = cell.column as any;
                      const { key, role, style } = cell.getCellProps({
                        bold: bold ? 1 : 0,
                        a: a ? 1 : 0,
                      });
                      return (
                        renderTableCell?.(cell) ?? (
                          <CustomTableCellCN key={key} role={role} width={style?.width} style={{ fontWeight: 500 }}>
                            <Link to={`${redirectTo || 'ver'}/${row.original.id}`} css="text-decoration: none;">
                              {cell.render('Cell')}
                            </Link>
                          </CustomTableCellCN>
                        )
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Container>
      </RelativeContainer>
    </div>
  );
}
